import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p417123438223769600',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
